export type Variant = 'launch' | 'install' | 'start';

export function detectVariant(): Variant {
  const path = window.location.pathname;
  if (path.startsWith('/install')) return 'install';
  if (path.startsWith('/start')) return 'start';
  return 'launch';
}
